import { render, staticRenderFns } from "./StoresListView.vue?vue&type=template&id=66ca4a2c&scoped=true&"
import script from "./StoresListView.vue?vue&type=script&lang=js&"
export * from "./StoresListView.vue?vue&type=script&lang=js&"
import style0 from "./StoresListView.vue?vue&type=style&index=0&id=66ca4a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca4a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow})
